import React, {Component} from 'react';

class RetryView extends Component {

  constructor(props) {
    super(props);
  }

  // retry callback event handler
  retryHandler() {
    this.props.retryCallback();
  }

  render() {
    return (
      <div className="statistic_refresh info_none">
        <span className="wrap_ico"><span className="ico_blog ico_post"></span></span>
        <button className="link_none" onClick={() => this.retryHandler()}>다시 조회하기</button>
      </div>
    );
  }
}

export default RetryView;
